import { variables } from '../common/variables';
import {
  cl,
  capitalizeFirstLetter,
  getUnique,
  trimToLowerCase,
  makeScrollbar
} from '../common/functions';
import { map, markersCluster } from './leaflet/leaflet__map-init';
import { tagFilterButtonCustom } from './leaflet/leaflet-tag-filter-button--custom'

const createFilters = (arrayTypesCategories, arrayCategories, group, types) => {
  /*------------ [FILTERS] ------------*/
  //creation d'une array clean pour creer les filtres
  const createFilterArray = () => {
    let mapArrayLowerCase = [];
    arrayCategories = getUnique(arrayCategories);
    for (let i = 0; i < arrayCategories.length; i++) {
      mapArrayLowerCase.push(`optGroup__separator--${trimToLowerCase(arrayCategories[i])}`);
      for (let j = 0; j < arrayTypesCategories.length; j++) {
        if (trimToLowerCase(arrayCategories[i]) === trimToLowerCase(arrayTypesCategories[j][0])) {
          mapArrayLowerCase.indexOf(trimToLowerCase(arrayTypesCategories[j][1])) === -1 ? mapArrayLowerCase.push(trimToLowerCase(arrayTypesCategories[j][1])) : null;
          mapArrayLowerCase.indexOf(trimToLowerCase(arrayTypesCategories[j][2])) === -1 ? mapArrayLowerCase.push(trimToLowerCase(arrayTypesCategories[j][2])) : null;
        }
      }
    }
    mapArrayLowerCase = mapArrayLowerCase.filter(item => item);

    // Exception pour les couleurs dans les types
    if (!!types.length) {
      // check si les types sont un object ou un array
      if (!Array.isArray(types[0]) && typeof types[0] === 'object') {
        [...mapArrayLowerCase].forEach(element => {
          const index = mapArrayLowerCase.indexOf(element);
          [...types].forEach(type => {
            if (type.name.toLowerCase() === element) {
              mapArrayLowerCase[index] = { name: element, color: type.color }
            }
          });
        });
      }
    }
    return mapArrayLowerCase;
  };
  /*------------ [LEAFLET] ------------*/
  // Filtres event
  const statusFilterButton = tagFilterButtonCustom({
    data: createFilterArray(),
    header: `Filtrer les résultats`,
    clearText: 'Réinitialiser les filtres',
    filterOnEveryClick: true,
    closeOnEveryClick: false,
    container: window.innerWidth >= variables.breakpoint ? "#stores__filters" : "#searchTab__filters",
    storeItemSelector: '.container__item',
    onSelectionComplete: (tags) => {
      map.fitBounds(group.getBounds().pad(0));
    }
  })
    .addTo(map);
  // Enable MCG integration
  statusFilterButton.enableMCG(markersCluster);
}

export { createFilters };
